import { useLocation } from 'react-router-dom';
import useAuth from './UseAuth';
import StateContainer, { StateContext } from './components/StateContainer';
import RoutesSite from './Routes';
import { useContext, useEffect } from 'react';
import { Navigate } from 'react-router-dom';
import Navbar from './components/Navbar';
import Sidebar from './components/Sidebar';
import axios from 'axios';

function App() {
  const history = useLocation();
  const banRoute =
    history.pathname === '/login' || history.pathname === '/demo';
  useAuth(history);
  const { userProfileData, setUserProfileData, token } =
    useContext(StateContext);

  // useEffect(() => {
  //   const datiContestoSito = {
  //     userUID: '12345-abcde-67890-fghij',
  //     responseContext: 'Useful info',
  //     knowledgeTag: ['cluster1', 'cluster2'],
  //     trackingData: {
  //       customTrackingData1: 'customTrackingDataValue1',
  //       customTrackingData2: 'customTrackingDataValue2',
  //       customTrackingData3: 'customTrackingDataValue3',
  //     },
  //     customVariables: {
  //       nome_utente: 'Andrea',
  //     },
  //   };

  //   // Usa la funzione globale
  //   window.tailorgpt.setContext(datiContestoSito);
  // }, []);

  // useEffect(() => {
  //   const dati = {
  //     descrizione:
  //       "Quelli sotto elencati sono i dati dell'utente che ti sta per scrivere. Tienili a mente quando devi rispondergli",
  //     nome: 'Mario Rossi',
  //     eta: 30,
  //     professione: 'Impiegato',
  //     hobby: 'Sport',
  //     userUID: '12345-abcde-67890-fghij',
  //   };

  //   window.tailorgpt.setContext(dati);
  // }, []);

  useEffect(() => {
    const token = localStorage.getItem('token');

    if (!token) {
      <Navigate to="/login" />;
    }
  });

  useEffect(() => {
    axios({
      method: 'post',
      url: `${process.env.REACT_APP_BASE_URL}/user/detail`,
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
        Authorization: 'Bearer ' + token,
      },
    })
      .then((response) => {
        setUserProfileData([response.data.response.user]);
      })
      .catch((error) => {
        console.error(error);
      });
  }, []);

  return (
    <div className="App">
      {!banRoute ? (
        <div id="layout-wrapper">
          <Navbar userProfileData={userProfileData} />
          <Sidebar userProfileData={userProfileData} />
          <RoutesSite />
        </div>
      ) : (
        <RoutesSite />
      )}
    </div>
  );
}

export default App;
